import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  min-height: max-content;
  display: flex;
  flex-direction: column;
  gap:15px;
  height: 100%;
  gap:20px;
  background:#E9E9E9;

  @media (max-width: 768px) {
    padding: 16px 13px 16px;
    overflow-x: hidden;
  }
`
export const ArtistsHead = styled.div`
  padding:20px;
  width: 100%;
  height: 219px;
  border-radius: 30px;
  background:#FFFFFF;  

  @media (max-width: 768px) {
    height: auto;
    border-radius: 20px;
    padding: 16px;
  }
`
export const Overview = styled.div`
  padding:21px 19px;
  width: 100%;
  min-height: 140px;
  border-radius: 30px;
  background:#FFFFFF;
  position:relative;

  @media (max-width: 768px) {
    border-radius: 20px;
    padding: 16px;
  }
`
export const Channel = styled.div`
  width: 100%;
  min-height: 140px;
  border-radius: 30px;
  background: #ffffff;
  padding: 20px;
  position: relative;

  @media (max-width: 768px) {
    border-radius: 20px;
    padding: 16px;
  }
`
export const Products = styled.div`
  position: relative;
  width: 100%;
  min-height: 212px;
  border-radius: 30px;
  background:#FFFFFF;
  padding: 21px 19px;

  @media (max-width: 768px) {
    border-radius: 20px;
    padding: 16px;
  }
`
export const Headline = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0;
  text-align: right;
  vertical-align: middle;
  color: #00000080;
  cursor: pointer;
`
export const CoverBox = styled.img``
export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 25px;
  letter-spacing: 0;
  vertical-align: middle;
  color:#000000;
`
export const Content = styled.div`
  width:100%;
  padding-left:1px;
  padding-top:20px;
  display:flex;
  gap:216px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 14px;
    padding-top: 14px;
  }
`
export const UnLinkBox = styled.div`
  width:100%;
  height:100%;
  display:flex;
  align-items: center;
  justify-content: center;
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #A4A4A4;
`
export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
`
export const TextTitle = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  color:#00000080;
`
export const Text = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
`
export const YoutubeBox = styled.div`
  display: flex;
  align-items: center;
  gap:5px;
`
export const AddBox = styled.div`
  display: flex;
  align-items: center;
  gap:4px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color:#6777FF;
  cursor:pointer;
`
export const ArtistInfo = styled.div`
  padding-top:20px;
  display: flex;
  justify-content: space-between;
  gap:10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding-top: 14px;
  }
`
export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
`
export const NameBox = styled.div`
  min-width: 166px;
  height: 39px;
  left: 510px;
  border-radius: 8px;
  border: 1px solid #A4A4A4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap:5px;
  padding: 11px 10px 12px 16px;
`
export const Info = styled.div`
  display: flex;
  align-items: center;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  color: #00000080;
`
export const Round = styled.div`
  width: 4px;
  height: 4px;
  border-radius:50%;
  background:#00000080;
`
export const IdInfo = styled.div`
  display: flex;
  align-items: center;
  gap:8px;
`
export const ArtistInfoBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`
export const DeleteBox = styled.div`
  width: 103px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: 1px solid #A4A4A4;
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  color: #A4A4A4;
  cursor:pointer;

  @media (max-width: 768px) {
    width: 100%;
    height: 36px;
  }
`
export const EditBox = styled.div`
  display:flex;
  gap:5px;
  input{
    min-width:100px;
    border:none;
    border-left:1px solid #000000;
    outline:none;
    font-family: SF Pro Display;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 0;
  }
`
export const Input = styled.div`
  padding-left:5px;
  display:flex;
  align-items: center;
  justify-content: center;
  width: 166px;
  height: 39px;
  border-radius: 8px;
  border: 1px solid #000000;

  @media (max-width: 768px) {
    width: 100%;
  }
`
export const Save = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  vertical-align: middle;
  cursor:pointer;
  width: 60px;
  height: 39px;
  border-radius: 8px;
  color: #FFFFFF;
  background: ${({ disabled }) => (disabled ? '#6777FF80' : '#6777FF')};
`
export const LoadingBox = styled.div`
  background: #FFFFFF;
  position: relative;
  height:20vh;
`
export const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index:9999
`;

export const ModalBox = styled.div`
  width: 520px;
  height: auto;
  opacity: 1;
  border-radius: 10px;
  background: #FFFFFF;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
  gap:4px;
  padding: 17px 14px;
`
export const ButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width:100%;
  display:flex;
  margin-top: 10px;
  cursor:pointer;
`
export const ModalButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  display:flex;
  margin-top: 10px;
  cursor:pointer;
`
export const YesBox = styled.div`
  width: 60px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #6777FF;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
`
export const ModalTitle = styled.div`
  font-family: SF Pro Display;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0;
  color:#000000;
`
export const ModalName = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  color:#00000080;
`
export const InputBox = styled.input`
  width: 100%;
  height: 39px;
  border-radius: 8px;
  border: 1px solid #00000080;
  padding: 13px 15px 11px;
  margin-top:7px;
`
export const ProductsHeadBox = styled.div`
  width: 100%;
  height: 39px;
  border-radius: 10px;
  background:#F6F6F6;
  display:flex; 
  align-items: center;
  gap:40px;
  margin-top:15px;
  margin-bottom: 10px;
`
export const HeadBox = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #7C7C7C;
  padding:0 20px 0 78px;
`
export const PaginatorWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;
  width: 100%;

  /* Keep paginator in one row: reserve space for rows-per-page dropdown and prevent wrapping */
  .p-paginator {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    padding-right: 72px;
    flex-wrap: nowrap;
    align-items: center;
  }

  .p-paginator-pages {
    white-space: nowrap;
  }

  .p-paginator-first,
  .p-paginator-prev,
  .p-paginator-next,
  .p-paginator-last {
    flex: 0 0 auto;
  }

  .p-paginator-rpp-options,
  .p-paginator .p-dropdown {
    position: absolute;
    right: 0;
  }

  @media (max-width: 768px) {
    /* Full-bleed inside Products padding so paginator doesn't wrap */
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-right: -16px;
    padding: 0 16px;
  }
`
export const ReleasesRow = styled.div`
  width: 100%;
  height: 41px;
  border-radius: 10px;
  display:flex;
  align-items: center;
  padding:0 20px;

`

export const ReleasesList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const CoverImg = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 4px;
`
export const RoundBox = styled.div`
  background:#87FF9B;
  width: 13px;
  height: 13px;
  border-radius:50%;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ReleaseTitle = styled.div`
  width: 180px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000;
  padding-left:11px;
`

export const ReleaseData = styled.div`
  width:150px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000;
`
export const ReleaseDataBox = styled.div`
  padding-left:7px
  width:120px;
  display:flex;
  align-items: center;
  gap:4px;
`
export const ReleaseDataBigBox = styled.div`
  display:flex;
  align-items: center;
`
export const ReleaseISRC = styled.div`
  display:flex;
  align-items: center;
  gap:8px;
  width:170px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000;
`
export const NoBox = styled.div`
  width: 60px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
`
export const TextBox = styled.div`
  width:374px;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: SF Pro Display;
  font-weight: 700;
  font-style: Bold;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 16px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #000000;
`
export const YoutubeRound = styled.div`
  min-width: 261px;
  height: 39px;;
  border: 1px solid #A4A4A4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding:11px 11px 10px 13px;
  
  input{
    width: 100%;
    border:none;
    border-left:1px solid #A4A4A4;
    outline:none;
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0;
    vertical-align: middle;
  }

  @media (max-width: 768px) {
    min-width: 100%;
    width: 100%;
  }
`
export const SocialBox = styled.div`
  width:100%;
  display:flex;
  flex-direction: column;
  align-items: center;
  gap:7px;
`
export const ContentBox = styled.div`
  width:100%;
  gap:15px;
  display:flex;
  flex-direction: column;
  align-items: center;
  margin-top:15px;
`
export const SocialInput = styled.div`
  width:100%;
  height: 39px;
  border-radius: 8px;
  border: 1px solid #E9E9E9;
  display:flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 11px 44px 10px 12px; /* leave room for copy button overlay on the right */
    input{
      width:100%;
      border:none;
      outline:none;
      padding-right: 34px;
    }

  /* Always-visible copy action pinned to the right */
  .copyAction {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
  }
   
  @media (max-width: 768px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`

export const AddCover = styled.div`
  width: 133px;
  height: 133px;
  border-radius: 15px;
  background: #E9E9E9;
  display:flex;
  align-items: center;
  justify-content: center;
`

export const CoverAddBox = styled.div`
  width: 101px;
  height: 33px;
  border-radius: 7px;
  background: #FFFFFF;
  font-family: SF Pro Display;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color:#000000;
  display:flex;
  align-items: center;
  justify-content: center;
  cursor:pointer;
`
export const ModalBody = styled.div`
  padding: 30px 56px;
  display:flex;
  gap:15px;
  flex-direction: column;
  align-items: center;
  justify-content: center
`
export const ModalHead = styled.div`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
`
export const BlueText = styled.span`
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color:#6777FF;
  white-space:nowrap;
  span {
    white-space:normal;
    font-family: SF Pro Display;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    vertical-align: middle;
    color:#000000;
  }
`
export const ModalTextBox = styled.div`
  text-align:center;

  
`

export const FooterBox = styled.div`
  margin-top:5px;
  display:flex;
  align-items: center;
  gap:10px;
  cursor:pointer;
`

export const AddPhoto = styled.div`
  width: 119px;
  height: 35px;
  border-radius:8px;
  background:#6777FF;
  font-family: SF Pro Display;
  font-weight: 600;
  font-style: Semibold;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color:#FFFFFF;
  display:flex;
  align-items: center;
  justify-content: center
`

export const DeleteModalBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:35px 0;
`
export const FileInput = styled.input`
  display: none;
`;

export const PreviewImage = styled.img`
  width: 133px;
  height: 133px;
  border-radius: 15px;
`;
export const PreviewBox = styled.div`
  position: relative;
`
export const PreviewBoxRound =  styled.div`
  position: absolute;
  bottom: 9px;   
  right: 12px;   
  width: 21px;
  height: 21px;
  border-radius:50%;
  background:#FFFFFF;
  z-index:9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:2px;
  cursor:pointer;
  &:hover .popupBox {
      display: flex;
      flex-direction: column;
      padding-top:13px;
    }
`;
export const HoverPopupBox =styled.div`
  position: absolute;
  top: 20px;
  left: 0;
  display: none;
`
export const HoverPopup = styled.div`
  width: 182px;
  height: 182px;
  border-radius: 10px;
  white-space: nowrap;
  z-index: 9999999;
  background:#FFFFFF;
  padding:15px 11px;
  box-shadow: 0px 0px 10px 3px #BCBCBFAD;
`;
export const BlackRound = styled.div`
  width: 3px;
  height: 3px;
  border-radius:50%;
  background:#000000;
`
export const HoverPopupText = styled.div`
  width: 160px;
  height: 39px;
  border-radius: 10px;
  padding:10px 8px 11px;
  &:hover {
    background: #E2E5FF;
    cursor:pointer;
  }
`
export const IconWrapper = styled.div`
  padding-right:8px;
`
export const BigImageBox = styled.div`
  background:#292D32E5;
  position:relative;
`
export const CloseBox = styled.div`
    position: absolute;
    z-index:999;
    right:-18px;
    top:-18px;
    cursor:pointer;
`

export const IconWrapperBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap:10px;`

export const IconWrapperBigBox = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap:10px;`

export const HorizontalScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ReleaseVersion = styled.div`
  width:233px;
  font-family: SF Pro Display;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #000000;
  `